<template>
  <div class="sidemenu">
    <div class="sidemenu-menu">
      <router-link
        to="/orders"
        active-link="active"
        class="sidemenu-menu__item p-ripple"
        v-ripple
      >
        <img
          :src="require(`../assets/images/briefcase.svg`)"
          alt=""
          class="sidemenu-menu__item-icon"
        />
        <p class="sidemenu-menu__item-text">Мои заказы</p>
      </router-link>
      <router-link
        to="/profile"
        active-link="active"
        class="sidemenu-menu__item p-ripple"
        v-ripple
      >
        <img
          :src="require(`../assets/images/profile-user.svg`)"
          alt=""
          class="sidemenu-menu__item-icon"
        />
        <p active-link="active" class="sidemenu-menu__item-text">Профиль</p>
      </router-link>
      <router-link
        to="/offers"
        active-link="active"
        class="sidemenu-menu__item p-ripple"
        v-ripple
      >
        <img
          :src="require(`../assets/images/refund.svg`)"
          alt=""
          class="sidemenu-menu__item-icon"
        />
        <p class="sidemenu-menu__item-text">Заявления на возврат</p>
      </router-link>
      <router-link
        to="/issues"
        active-link="active"
        class="sidemenu-menu__item p-ripple"
        v-ripple
      >
        <img
          :src="require(`../assets/images/support-subject.svg`)"
          alt=""
          class="sidemenu-menu__item-icon"
        />
        <p class="sidemenu-menu__item-text">Обращения в поддержку</p>
      </router-link>
      <router-link
        to="/contacts"
        active-link="active"
        class="sidemenu-menu__item p-ripple"
        v-ripple
      >
        <img
          :src="require(`../assets/images/call.svg`)"
          alt=""
          class="sidemenu-menu__item-icon"
        />
        <p class="sidemenu-menu__item-text">Контакты</p>
      </router-link>
      <a
        href="https://www.biletdv.ru/Pages/HelpDesk#AviaTickets"
        class="sidemenu-menu__item p-ripple sidemenu-refund"
        v-ripple
      >
        <img
          :src="require(`../assets/images/question.svg`)"
          alt=""
          class="sidemenu-menu__item-icon"
        />
        <p class="sidemenu-menu__item-text">Часто задаваемые вопросы</p>
      </a>
      <router-link
        to="/profile"
        active-link="active"
        class="sidemenu-menu__item p-ripple"
        v-ripple
      >
        <img
          :src="require(`../assets/images/money.svg`)"
          alt=""
          class="sidemenu-menu__item-icon"
        />
        <p class="sidemenu-menu__item-text">Бонусный счёт:</p>
        <p class="sidemenu-menu__item-score">{{ scores.Value + " баллов" }}</p>
      </router-link>
    </div>
    <div class="sidemenu-exit" @click="logout">
      <span>Выход</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";
import Ripple from "primevue/ripple";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import router from "../router";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "SideMenu",
  setup() {
    function getUserData() {
      const data = sessionStorage.getItem("userInfo");
      if (data !== null) {
        return JSON.parse(data);
      }
    }
    const router = useRouter();
    const route = useRoute();
    return {
      getUserData,
      router,
      route,
    };
  },
  data() {
    return {
      scores: this.getUserData(),
    };
  },
  methods: {
    ...mapActions("auth", {
      actionLogout: "logout",
    }),
    logout() {
      axioCred.post(`https://www.biletdv.ru/customer/IBEServices/Logout`).then((res) => {
        if (res.status == 200) {
          this.isOpened = !this.isOpened;
          this.actionLogout();
          router.push("/login");
        }
      });
    },
  },
  directives: {
    ripple: Ripple,
  },
});
</script>

<style>
.sidemenu {
  min-width: 30%;
}

.sidemenu-menu {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sidemenu-menu__item {
  display: flex;
  align-items: center;
  padding: 15px 15px 15px 0;
  border-bottom: 0.5px solid rgb(209, 209, 209);
  text-decoration: none;
}
.sidemenu-refund {
  text-decoration: none;
}

.sidemenu-menu__item:last-child {
  border: none;
}

.sidemenu-menu__item:first-child {
  margin-top: 0;
}

.sidemenu-menu__item:hover {
  background-color: rgb(238, 238, 238);
}

div .sidemenu-menu__item:hover {
  background-color: rgb(238, 238, 238);
}

.sidemenu-menu__item-icon {
  width: 27px;
  height: 27px;
  margin-left: 15px;
}

.sidemenu-menu__item-text {
  font-size: 18px;
  color: #000;
  margin-left: 15px;
}

.sidemenu-menu__item-score {
  font-size: 18px;
  color: rgb(44, 186, 190);
  margin-left: 5px;
}

.sidemenu-exit {
  max-width: 70%;
  cursor: pointer;
  padding: 10px;
  margin-top: 15px;
  font-size: 18px;
  text-align: center;
  background-color: #eee;
  border-radius: 5px;
  overflow: hidden;
  border: 0.5px solid #bbb;
  margin-left: auto;
  margin-right: auto;
}

.sidemenu-exit:hover {
  background-color: rgb(255, 255, 255);
}
</style>
